<template>
  <div class="info__team">
    <section class="team__item team__item--padding">
      <div class="team__list-cont">
        <h3 class="team__title" data-anim="text">TEAM</h3>

        <ul class="tema__list">
          <li
            class="list__item"
            v-for="member in data.members"
            :key="member"
            data-anim="text"
          >
            {{ member }}
          </li>
        </ul>
      </div>
    </section>

    <section class="team__item">
      <figure data-parallax="0.2">
        <img v-lazy="switchImg" :alt="data.image.alt">
        <div class="team__image" v-lazy:background-image="switchImg"></div>
      </figure>
    </section>
  </div>
</template>

<script>
export default {
  name: 'InfoTeam',

  props: ['data'],


  computed: {
    switchImg() {
      if ((window.chrome && window.chrome.webstore) || (window.opr && window.opr.addons)) {
        return `${this.data.image.src}.webp`;
      }
      return `${this.data.image.src}.jpg`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.info__team {
  position: relative;
  padding: 100px 40px 0 40px;

  display: flex;
  flex-flow: column;
  align-items: center;

  @include mq(sm) {
    flex-flow: wrap;
    justify-content: space-between;
    padding: 100px 0 0 0;
  }

  .team__item {
    width: 100%;
    text-align: right;

    @include mq(sm) {
      width: calc(40% - 60px);
    }

    .team__list-cont {
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
      padding-bottom: 40px;

      @include mq(sm) {
        justify-content: flex-end;
        padding-bottom: 0;
      }
    }

    h3,
    ul {
      position: relative;
      display: inline-block;
      text-align: left;
    }

    h3 {
      margin-right: 40px;
      font-weight: 500;
      font-size: 1rem;
      color: $color-dark-gray;
    }
  }

  figure {
    position: relative;
    width: 100%;
    margin: 0;
    padding: 0;

    overflow: hidden;

    @include aspect-ratio(5, 4);

      @include mq(sm) {
      width: calc(100% + 40px);
    }

    img {
      @include visually-hidden;
    }
  }

  .team__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }


  .team__item:nth-child(even) {
    width: 100%;

    @include mq(sm) {
      width: calc(60% - 60px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoTeam.vue